// Textos del panell de la flota de taxi/VTC (`/fleet/:fleetId/…`, fase 3 de
// docs/flotas-drivers). Es registren a AppComponent i es fusionen amb
// drivers-fleet/ca.ts.
export const locale = {
  lang: 'ca',
  data: {
    DRIVERS_FLEET: {
      PANEL: {
        ACTIONS: 'Accions',
        EDIT: 'Editar',
        SAVED: 'Desat',
        COPY: 'Copiar',
        COPIED: 'Copiat',
        DATE_FROM: 'Des de',
        DATE_TO: 'Fins a',
        RANGE_INVALID: 'La data «Des de» no pot ser posterior a «Fins a».',
        GENERIC_ERROR: 'No s’ha pogut completar l’acció. Torna-ho a provar.',
        WEEKDAY: { 1: 'Dilluns', 2: 'Dimarts', 3: 'Dimecres', 4: 'Dijous', 5: 'Divendres', 6: 'Dissabte', 7: 'Diumenge' },
        OVERVIEW: {
          LOAD_ERROR: 'No s’ha pogut carregar el resum.',
          KPI_FEE: 'Quota al passatger',
          KPI_FEE_NOTE: 'No es descompta de la teva facturació',
          ALERTS_TITLE: 'Necessita la teva atenció',
          START_TITLE: 'Primers passos',
          START_SUB: '{{done}} de {{total}} fets. Amb tot a punt, els teus conductors poden començar a treballar.',
          START_GO: 'Començar',
          CHART_TITLE: 'Viatges per dia',
          CHART_Q: 'Quants viatges han fet els teus conductors en els últims {{days}} dies?',
          CHART_EMPTY: 'Encara no hi ha viatges en aquest període.',
          TIP_TRIPS: 'Viatges',
          TOP_EMPTY: 'Sense viatges en aquest període.',
          TOP_TRIPS: '{{count}} viatges',
        },
        DRIVERS: {
          TABS_ARIA: 'Estat dels conductors',
          COL_DRIVER: 'Conductor',
          COL_DOCUMENTS: 'Documents',
          DOCS_TOOLTIP:
            'Aprovats: {{approved}} · En revisió: {{inReview}} · Rebutjats: {{rejected}} · Pendents: {{pending}} · Caducats: {{expired}}',
          EMPTY_FILTERED: 'Cap conductor coincideix amb la cerca.',
          LOAD_ERROR: 'No s’han pogut carregar els conductors.',
          SHOWING: 'Mostrant {{shown}} de {{total}} conductors',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Conductors per pàgina',
          ACCEPT: 'Acceptar',
          ACCEPTING: 'Acceptant…',
          ACCEPT_TITLE: 'Acceptar el conductor',
          ACCEPTED_TITLE: '{{name}} ja forma part de la flota',
          ACCEPT_ERROR: 'No s’ha pogut acceptar la sol·licitud.',
          EMPLOYMENT_LABEL: 'Com treballa per a la flota',
          EMPLOYMENT_REQUIRED: 'Tria si és autònom o assalariat.',
          SELF_EMPLOYED_HINT: 'Factura els seus viatges i es queda un % del que cobra.',
          SALARIED_HINT: 'Treballa amb contracte: la flota cobra els viatges íntegres.',
          SHARE_LABEL: '% que es queda el conductor',
          SHARE_PLACEHOLDER: 'El de la flota',
          SHARE_HINT: 'Si ho deixes buit, s’aplica el repartiment per defecte de la flota.',
          SHARE_INVALID: 'Posa un percentatge entre 0 i 100.',
          REJECT: 'Rebutjar',
          REJECTING: 'Rebutjant…',
          REJECTED_DONE: 'Rebutjada',
          REJECT_TITLE: 'Rebutjar la sol·licitud de {{name}}',
          REJECT_TEXT: 'No entrarà a la flota. Pot tornar-ho a demanar amb el codi.',
          REJECT_PLACEHOLDER: 'Motiu (opcional, el veurà el conductor)',
          REJECT_ERROR: 'No s’ha pogut rebutjar la sol·licitud',
          REGENERATE: 'Canviar codi',
          REGENERATING: 'Canviant…',
          REGENERATED: 'Canviat',
          REGENERATE_TITLE: 'Canviar el codi de flota',
          REGENERATE_TEXT: 'El codi actual deixa de valer. Els conductors ja vinculats no es veuen afectats.',
          REGENERATE_ERROR: 'No s’ha pogut canviar el codi',
        },
        DRIVER: {
          TITLE: 'Fitxa del conductor',
          LOAD_ERROR: 'No s’ha pogut carregar el conductor.',
          DOCS_TITLE: 'Documents',
          DOCS_SUB: 'Els revisa WAIIS. Aquí només en veus l’estat; el conductor els puja des de l’app.',
          DOCS_EMPTY: 'Encara no ha pujat cap document.',
          REMOVE: 'Desvincular',
          REMOVING: 'Desvinculant…',
          REMOVED: 'Desvinculat',
          REMOVE_TITLE: 'Desvincular {{name}}',
          REMOVE_TEXT: 'Deixarà de treballar per a la flota i se’l traurà de tots els seus torns.',
          REMOVE_ERROR: 'No s’ha pogut desvincular el conductor',
          REMOVED_SHIFTS: 'Conductor desvinculat. S’han alliberat {{count}} franges de torn.',
        },
        VEHICLES: {
          ADD: 'Afegir vehicle',
          TABS_ARIA: 'Estat dels vehicles',
          TAB_ALL: 'Tots',
          COL_PLATE: 'Matrícula',
          COL_SEATS: 'Places',
          LICENSE_taxi: 'Núm. de llicència municipal',
          LICENSE_vtc: 'Núm. d’autorització VTC',
          EMPTY: 'Encara no has donat d’alta cap vehicle.',
          EMPTY_FILTERED: 'Cap vehicle coincideix amb els filtres.',
          LOAD_ERROR: 'No s’han pogut carregar els vehicles.',
          SHOWING: 'Mostrant {{shown}} de {{total}} vehicles',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Vehicles per pàgina',
          BRAND: 'Marca',
          MODEL: 'Model',
          PLATE_INVALID: 'La matrícula no és vàlida.',
          DELETE: 'Donar de baixa',
          DELETING: 'Donant de baixa…',
          DELETED: 'Donat de baixa',
          DELETE_TITLE: 'Donar de baixa el {{plate}}',
          DELETE_TEXT: 'El vehicle surt de la flota i se’n treu de tots els torns.',
          DELETE_ERROR: 'No s’ha pogut donar de baixa el vehicle',
          DELETED_SHIFTS: 'Vehicle donat de baixa. S’han alliberat {{count}} franges de torn.',
        },
        SHIFTS: {
          SAVE: 'Desar torns',
          DISCARD: 'Descartar canvis',
          LOAD_ERROR: 'No s’han pogut carregar els torns.',
          SAVE_ERROR: 'No s’han pogut desar els torns.',
          LOCKED: 'Per organitzar els torns cal almenys un vehicle i un conductor acceptat.',
          FREE: 'lliure',
          OUTDATED_TITLE: 'Els torns han canviat',
          RELOAD: 'Tornar a carregar',
        },
        DOCUMENTS: {
          LOAD_ERROR: 'No s’han pogut carregar els documents.',
          COMPANY: 'Empresa',
          URGENCY: {
            in_review: 'En revisió',
            valid: 'Al dia',
          },
          EMPTY: 'Encara no hi ha vehicles a la flota.',
          UPLOADED_AT: 'Pujat el {{date}}',
          VIEW_ERROR: 'No s’ha pogut obrir el document.',
        },
        SETTLEMENTS: {
          EXPORT: 'Exportar CSV',
          INFO_TITLE: 'De moment, només informatiu',
          SUMMARY_ERROR: 'No s’ha pogut carregar el resum.',
          NEXT_PAYOUT: 'Propera liquidació',
          DEFAULT_SHARE: 'Repartiment per defecte',
          MOVEMENTS_TITLE: 'Moviments',
          MOVEMENTS_SUB:
            'Cada fila són diners que ja s’han mogut. La quota al passatger (només en serveis de l’app WAIIS; els teus clients propis van a 0 €) es paga a sobre de la tarifa: tu cobres la tarifa íntegra.',
          TYPE_ALL: 'Tots els tipus',
          TYPE_ARIA: 'Tipus de moviment',
          TYPE: {
            trip_earning: 'Viatge',
            driver_share: 'Part del conductor',
            payout: 'Liquidació',
            adjustment: 'Ajust',
          },
          DRIVER_ALL: 'Tots els conductors',
          DRIVER_ARIA: 'Conductor',
          COL_DATE: 'Data',
          COL_TYPE: 'Tipus',
          COL_DRIVER: 'Conductor',
          COL_DESCRIPTION: 'Descripció',
          COL_FARE: 'Tarifa',
          COL_COMMISSION: 'Quota',
          COL_PASSENGER: 'Paga el passatger',
          COL_AMOUNT: 'Import flota',
          COMMISSION_TOOLTIP: 'La paga el passatger a més de la tarifa, només en els serveis que arriben per l’app WAIIS. No es descompta del que cobra la flota.',
          EMPTY: 'No hi ha moviments en aquest període.',
          LOAD_ERROR: 'No s’han pogut carregar els moviments.',
          SHOWING: 'Mostrant {{shown}} de {{total}} moviments',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Moviments per pàgina',
        },
        REPORTS: {
          EXPORT_ERROR: 'No s’ha pogut descarregar l’informe.',
          COL_TRIPS: 'Viatges',
          COL_HOURS: 'Hores connectat',
          COL_FARE: 'Facturació',
          COL_ACCEPTANCE: 'Acceptació',
          COL_RATING: 'Valoració',
          EMPTY: 'Sense activitat en aquest període.',
          LOAD_ERROR: 'No s’ha pogut carregar el rendiment.',
          SHOWING: 'Mostrant {{shown}} de {{total}} conductors',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Conductors per pàgina',
        },
        TEAM: {
          INVITE: 'Convidar algú',
          INVITE_SUB: 'Li arribarà un correu per entrar al panell.',
          TITLE: 'Persones amb accés',
          SUB: 'Qui entra al panell de la flota i què pot fer.',
          COL_MEMBER: 'Persona',
          COL_ROLE: 'Rol',
          STATUS_invited: 'Convidat',
          STATUS_active: 'Actiu',
          EMPTY: 'Encara no hi ha ningú a l’equip.',
          LOAD_ERROR: 'No s’ha pogut carregar l’equip.',
          EMAIL: 'Correu electrònic',
          EMAIL_INVALID: 'Escriu un correu vàlid.',
          SEND_INVITE: 'Enviar invitació',
          INVITED_TITLE: 'Invitació enviada a {{email}}',
          CHANGE_ROLE: 'Canviar el rol',
          LAST_OWNER: 'La flota ha de tenir almenys un propietari.',
          REMOVE: 'Treure de l’equip',
          REMOVING: 'Traient…',
          REMOVED: 'Tret',
          REMOVE_TITLE: 'Treure {{name}} de l’equip',
          REMOVE_TEXT: 'Deixarà de tenir accés al panell de la flota.',
          REMOVE_TEXT_INVITED: 'La invitació deixarà de valer.',
          REMOVE_ERROR: 'No s’ha pogut treure de l’equip',
        },
        SETTINGS: {
          LOAD_ERROR: 'No s’han pogut carregar els ajustos.',
          COMPANY_TITLE: 'Dades de la flota',
          COMPANY_SUB: 'Com es diu i a quin correu t’escrivim.',
          NAME: 'Nom de la flota',
          CONTACT_EMAIL: 'Correu de contacte',
          MODE: 'Tipus de servei',
          LOCKED_FIELDS: 'El tipus de servei i la regió no es poden canviar. Si ho necessites, escriu a suport.',
          BILLING_SUB: 'A nom de qui facturem.',
          BILLING_WARN: 'En desar, les dades tornen a revisió. Mentrestant se segueix facturant amb les anteriors.',
          BILLING_IN_REVIEW: 'WAIIS està revisant els últims canvis. Podràs editar-los quan acabi.',
          SLOTS_TITLE: 'Franges de torn',
          SLOTS_SUB: 'Iguals per a tota la flota; la de nit pot passar de mitjanit. Si canvies les hores, s’apliquen a partir de la setmana vinent.',
          SLOT_START: 'Comença',
          SLOT_END: 'Acaba',
          SLOT_INVALID: 'Posa l’hora d’inici i de fi, i que no siguin iguals.',
          CROSSES_MIDNIGHT: 'Passa de mitjanit',
          NOTIFICATIONS_TITLE: 'Avisos per correu',
          NOTIFICATIONS_SUB: 'S’envien a {{email}}.',
          NOTIFY_documentExpiring: 'Un document caduca aviat',
          NOTIFY_documentRejected: 'WAIIS rebutja un document',
          NOTIFY_driverRequests: 'Un conductor demana entrar',
          NOTIFY_weeklySettlement: 'Resum setmanal de liquidacions',
        },
      },
    },
    PAGE_HEADER: {
      FLEET_DRIVERS: 'Accepta els conductors que es vinculen amb el teu codi de flota i consulta l’estat dels seus documents.',
      FLEET_VEHICLES: 'Els cotxes de la flota, la seva llicència i els seus documents.',
      FLEET_DOCUMENTS: 'L’estat i la caducitat dels documents de l’empresa i dels vehicles.',
      FLEET_SETTLEMENTS: 'El que ha facturat la flota i el repartiment de cada viatge.',
      FLEET_REPORTS: 'Els informes de viatges, conductors i liquidacions per descarregar.',
      FLEET_TEAM: 'Les persones que gestionen la flota amb tu i el seu rol.',
      FLEET_SETTINGS: 'Dades de la flota, facturació, franges de torn i avisos.',
    },
  },
};
